import React from 'react'
import FontAwesome  from 'react-fontawesome'

class Social extends React.Component {
    render(){
        return (
            <nav className="level is-mobile">
            <div className="level-left">
                <a className="level-item">
                <span className="icon is-small"><FontAwesome name="github"/></span>
                </a>
                <a className="level-item">
                <span className="icon is-small"><FontAwesome name="facebook"/></span>
                </a>
                <a className="level-item">
                <span className="icon is-small"><FontAwesome name="twitter"/></span>
                </a>
            </div>
            </nav>
        )
    }
}

export default Social


// WEBPACK FOOTER //
// ./src/components/Social.js